<script>
import Vue from 'vue'
import messages from '../mixins/messages'
import date from '../mixins/date'
import ListingResource from '../resources/listing'
import CompanyResource from '../resources/company'

export default Vue.extend({
    components: {},
    mixins: [messages, date],
    props: {
        listingResources: {
            type: Array,
            required: true,
            default() {
                return []
            }
        },
        actions: {
            type: Array,
            default() {
                return []
            }
        }
    },
    watch: {
        selected() {
            this.$emit('input', this.selected)
        }
    },
    data() {
        return {
            selected: [],
            loading: false,
        }
    },
    methods: {
        clearSelected() {
            this.selected = []
        },
        stringMaxLength(input, maxLength) {
            if (input.length > maxLength) {
                return input.substring(0, maxLength) + '...'
            }

            return input
        },
        async runActionHandler(fn) {
            fn(this.selected)
            this.selected = []
        }
    },
    beforeMount() {
        
    }
})
</script>

<template>
    <div>
        <b-table-simple small responsive striped>
            <b-thead>
                <b-tr>
                    <b-th width="10" v-if="actions.length > 0">&nbsp;</b-th>
                    <b-th>Job Title</b-th>
                    <b-th>Applicants</b-th>
                    <b-th>Created</b-th>
                    <b-th>Expires</b-th>
                    <b-th class="text-right">Status</b-th>
                </b-tr>
            </b-thead>

            <b-tbody v-if="listingResources.length > 0">
                <b-tr v-for="(resource, i) in listingResources" :key="i">
                    <b-td v-if="actions.length > 0"><b-form-checkbox v-model="selected" :value="resource" :checked-value="resource" /></b-td>
                    <b-td><strong><router-link :to="{ name: 'recruitJobView', params: { companyId: resource.attributes.company, listingId: resource.id } }">{{ stringMaxLength(resource.attributes['title'], 40) }}</router-link></strong></b-td>
                    <b-td>
                        <span v-if="resource.readonly.applicants_count"><b-badge pill variant="secondary">{{ resource.readonly.applicants_count }}</b-badge> / </span>
                        <router-link v-if="resource.status.variant === 'success'" :to="{ name: 'recruitSource', params: { companyId: resource.attributes.company }, query: { listing: resource.id } }">Browse</router-link>
                        <span v-else>&nbsp;</span>
                    </b-td>
                    <b-td>{{ dateStringToDatePretty(resource.attributes['created']) }}</b-td>
                    <b-td><span v-if="resource.attributes['expires']">{{ dateStringToDatePretty(resource.attributes['expires']) }}</span></b-td>
                    <b-td class="text-right">
                        <slot name="status" :resource="resource">
                            <big><b-badge :variant="resource.status.variant">{{ resource.status.text }}</b-badge></big>
                        </slot>
                    </b-td>
                </b-tr>
            </b-tbody>
        </b-table-simple>

        <b-button-group>
            <b-dropdown dropup text="With Selected" variant="secondary" v-if="selected.length > 0">
                <span v-for="(action, i) in actions" :key="i">
                    <b-dropdown-item v-if="action.handler && action.text" @click="runActionHandler(action.handler)">{{ action.text }}</b-dropdown-item>
                </span>
            </b-dropdown>
            <b-button variant="light" @click="selected = []" v-if="selected.length > 0">Clear</b-button>
        </b-button-group>
    </div>
</template>

<style lang="scss">
// table.fat {
//     border: 1px solid #dee2e6;

//     thead {
//         background: #dee2e6;
//     }

//     tbody {
//         tr {
//             td {
//                 padding: 2rem 0.75rem;
//             }
//         }
//     }
// }
</style>
